<template>
  <div>
    <Card>
      <p slot="title"> Nota Transaksi</p>
      <Row type="flex" justify="space-between" class="code-row-bg">
        <Col span="6">
        <ButtonGroup class="custom-group-parent">
          <Button class="custom-group">Tgl. Klaim</Button>
          <Date-picker v-model="filterClaimDate" style="width: 180px;" type="daterange" format="yyyy-MM-dd"
            @on-change="updateFilter">
          </Date-picker>
        </ButtonGroup>
        </Col>

        <Col span="6">
        <ButtonGroup class="custom-group-parent">
          <Button class="custom-group">Kode Nota</Button>
          <Input style="width: 250px;" v-model="filterNoteCode" @on-keyup="updateFilter"></Input>
        </ButtonGroup>
        </Col>

        <Col span="6">
        <ButtonGroup class="custom-group-parent">
          <Button class="custom-group">Marking</Button>
          <Select style="width: 250px;" v-model="markingIdSelected" filterable clearable
            :remote-method="getMarkingByCode" :loading="isLoadingMarking" @on-change="updateFilter">
            <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">{{ option.label }}</Option>
          </Select>
        </ButtonGroup>
        </Col>

        <Col span="2">
        <Button type="primary" icon="ios-search" @click="getTransactionNote" :disabled="!isSearchShow">
          <span>Cari</span>
        </Button>
        </Col>

        <Col span="2">
        <Spin size="large" v-show="isLoadingMarking"></Spin>
        </Col>
      </Row>

      <br />

      <!-- <Card>
        <cHotTransactionNoteClaim v-if="transactionNoteData.length > 0"
            :dataHot="transactionNoteData">
        </cHotTransactionNoteClaim>
      </Card> -->

      <Card>
        <Table :columns="columnsDataTable" :data="transactionNoteData" @on-selection-change="onSelectionChange"></Table>
      </Card>
    </Card>

    <div class="footer" v-show="transactionNotePrint.length > 0">
      <Button type="success" @click="modalConfirmMultiplePrint = true" icon="printer" size="small">
        <span>Cetak {{ transactionNotePrint.length }} data</span>
      </Button>
    </div>

    <!-- table-sheet hidden -->
    <div id="table-to-excel" ref="sheetsDataTableList" hidden></div>

    <!-- Modal Confirm Multiple Print -->
    <Modal v-model="modalConfirmMultiplePrint" width="50rem">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>Konfirmasi</span>
      </p>
      <div style="text-align:left; display: flex;">
        <div v-for="data in transactionNotePrint">
          <Tag color="blue">{{ data.noteCode }}</Tag>
        </div>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long icon="printer" @click="notePrint(transactionNotePrint)">Cetak</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
// import cHotTransactionNoteClaim from '@/components/claim/cHotTransactionNoteClaim';

import _ from 'lodash'
import moment from 'moment'
import * as XLSX from 'xlsx'

const numeral = require('numeral');

export default {
  // components: {
  //   cHotTransactionNoteClaim
  // },
  data() {
    return {
      filterClaimDate: [],
      filterNoteCode: '',
      markingIdSelected: '',
      isSearchShow: false,
      optionMarkings: [],
      isLoadingMarking: false,
      columnsDataTable: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'Kode Nota',
          key: 'noteCode'
        },
        {
          title: 'Marking',
          key: 'markingHeaderCode'
        },
        {
          title: 'Nomor Klaim',
          key: 'claim_number'
        },
        {
          title: 'Tanggal Klaim',
          key: 'claim_date'
        },
        {
          title: 'Tanggal Invoice',
          key: 'invoiceDate'
        },
        {
          title: 'No. Container',
          key: 'containerNumber'
        },
        {
          title: 'Keterangan',
          key: 'description'
        },
        {
          title: 'Total Nilai Klaim',
          key: 'total_claim'
        },
      ],
      transactionNoteData: [],
      transactionNotePrint: [],
      modalConfirmMultiplePrint: false
    }
  },
  methods: {
    showDateFormatted: function (stringToFormat) {
      let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
      return moment(dateToFormat).format("DD MMM YYYY")
    },
    getMarkingByCode: _.debounce(
      function (query) {
        if (query !== '') {
          this.isLoadingMarking = true;
          HTTP
            .post('marking/getBySnapshot', {
              markingHeaderId: query
            })
            .then(response => {
              this.isLoadingMarking = false;
              let data = response.data;

              const list = data.map(item => {
                return {
                  value: item.markingheaderid,
                  label: item.markingheadercode
                };
              });

              this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
            })
            .catch(e => {
              this.isLoadingMarking = false;
              this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
              });
            })
        } else {
          this.optionMarkings = [];
        }
      }, 400
    ),

    updateFilter: function () {
      let fTrxDate = this.filterClaimDate;
      let fNoteCode = this.filterNoteCode;
      let fMarkingSelected = this.markingIdSelected;

      if ((fTrxDate[0] != '' && fTrxDate[0] != null) || fNoteCode != '' || (fMarkingSelected != '' && fMarkingSelected != undefined)) {
        this.isSearchShow = true
      } else {
        this.isSearchShow = false
      }
    },

    getTransactionNote: function () {
      this.$Loading.start();

      // let fTrxDate = this.filterClaimDate != "" && this.filterClaimDate != null ? moment(this.filterClaimDate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null;
      let fStartDate = null;
      let fEndDate = null;
      if (this.filterClaimDate[0] != "" && this.filterClaimDate[0] != null) {
        fStartDate = moment(this.filterClaimDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
        fEndDate = moment(this.filterClaimDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
      }
      let fNoteCode = this.filterNoteCode != "" ? this.filterNoteCode.toUpperCase() : null;
      let fMarkingSelected = this.markingIdSelected != "" && this.markingIdSelected != undefined ? this.markingIdSelected : null;

      let payload = {
        isTrxNote: true,
        // claimDate: fTrxDate,
        startClaimDate: fStartDate,
        endClaimDate: fEndDate,
        noteCode: fNoteCode,
        markingHeaderId: fMarkingSelected
      }

      console.log({ payload });

      this.transactionNoteData = [];
      HTTP.post('claim/search', payload)
        .then(response => {
          let parent = this;
          let invoiceClaim = [];
          console.log({ response });

          _.forEach(response.data, function (value, index) {
            let total_claim = value.total_claim != null ? "Rp. " + numeral(value.total_claim).format('0,0') : '';
            let invoiceDate = value.receivable.invoice != null ? parent.showDateFormatted(value.receivable.invoice.invoicedate) : ''

            var containerNumber = '-'
            var containerCode = ''
            var invoicefee = value.receivable.debitAmount

            if (value.receivable.invoice != null) {
              invoiceDate = value.receivable.invoice != null ? parent.showDateFormatted(value.receivable.invoice.invoicedate) : ''
              containerNumber = value.receivable.invoice.packaging_list.container_loading != null ? value.receivable.invoice.packaging_list.container_loading.containernumber : ''
              containerCode = value.receivable.invoice.packaging_list.container_loading != null ? value.receivable.invoice.packaging_list.container_loading.containercode : ''
              invoicefee = value.receivable != null ? value.receivable.invoice.invoicefee : ''
            } else {
              invoiceDate = parent.showDateFormatted(value.receivable.transactionDate)
              containerNumber = '-'
              containerCode = ''
              invoicefee = value.receivable.debitAmount
            }

            let invoiceDueId = value.invoice_due != null ? value.invoice_due.id : ''
            let receivableRemaining = value.invoice_due != null ? value.invoice_due.receivableRemaining : ''

            let iClaim = {
              noteCode: value.noteCode,
              claimId: value.id,
              receivableId: value.receivableid,
              markingHeaderId: value.markingheaderid,
              markingHeaderCode: value.marking_header.markingheadercode,
              invoiceDate: invoiceDate,
              claim_date: value.claim_date != null ? parent.showDateFormatted(value.claim_date) : '',
              claim_number: value.claim_number,
              containerNumber: containerNumber,
              containerCode: containerCode,
              total_claim: total_claim,
              description: value.receivable.description,
              file: value.filename,
              claim_detail: value.claim_detail,
              isApprove: value.isApprove,
              invoiceFee: invoicefee,
              invoiceDueId: invoiceDueId,
              receivableRemaining: receivableRemaining,
              mutation: numeral(value.total_claim).format('0,0'),
              payment: value.payment
            }
            invoiceClaim.push(iClaim);
          });

          this.transactionNoteData = invoiceClaim;

          this.$Loading.finish();
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
    },

    onSelectionChange: function (selection) {
      this.transactionNotePrint = selection
    },
    notePrint(dataTrx) {
      console.log({ dataTrx });
      // set table html
      let tempData = `
            <table id="exportedTable" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides" border="2">
              <thead valign="top">
                <tr> <th colspan='6' style="font-weight: bold; font-family: Verdana; font-size: 20px; color: #990000;"> ${dataTrx[0].description} </th> </tr>
                <tr> <th colspan='6' style="font-weight: bold; font-family: Verdana; font-size: 20px; color: #990000;"> ${dataTrx[0].claim_date} </th> </tr>
                <tr> <th colspan='6' style="font-weight: bold; font-family: Verdana; font-size: 20px; color: #009933;"> NT - NR - KLAIM </th> </tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
                <tr><th></th><th></th><th></th><th></th><th></th><th></th></tr>
              </thead>

              <tbody>`;

      dataTrx.forEach(el => {
        // let formatedDate = moment(el.transactionDate).format('YYYY-MM-DD');

        tempData += `
                    <tr>
                      <td colspan="6">
                        <table>
                          <thead valign="top">
                            <tr>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black; font-weight: bold; font-family: Verdana; font-size: 8px; color: #3333cc;"> ${el.markingHeaderCode} </th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black; font-weight: bold; font-family: Verdana; font-size: 13px; color: #3333cc;"> ${el.noteCode} </th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black;"></th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black;"></th>
                              <th style="border-top: 1px solid black; border-bottom: 1px solid black;"></th>
                              <th style="border: 1px solid black; font-weight: bold; font-family: 'Times New Roman'; font-size: 12px;">PARAF</th>
                            </tr>
                          </thead>

                          <tr>
                            <td style="font-family: 'Times New Roman'; font-size: 12px; color: #ff0000"> ${el.claim_date} </td>
                            <td style="font-family: 'Times New Roman'; font-size: 12px; color: #ff0000"> ${el.description} </td>
                            <td></td>
                            <td style="font-family: 'Times New Roman'; font-size: 12px; color: #ff0000"> ${el.mutation} </td>
                            <td></td>
                            <td style="border-left: 1px solid black; border-right: 1px solid black;"></td>
                          </tr>

                          <tr>
                            <td></td><td></td><td></td><td>
                            </td><td></td><td style="border-left: 1px solid black; border-right: 1px solid black;"></td>
                          </tr>`;

        el.payment.map(function (payment) {
          payment.payment_allocate.map(function (payment_allocate) {
            tempData +=
              '<tr>' +
              '<td></td>' +
              '<td>' + payment_allocate.invoice_due_detail.receivable_detail.description + '</td>' +
              '<td></td>' +
              '<td></td>' +
              '<td>' + "Rp. " + numeral(payment_allocate.allocateAmount).format('0,0') + '</td>' +
              '<td style="border-left: 1px solid black; border-right: 1px solid black;"></td>' +
              '</tr>';
          });
        })

        tempData += `
                          <tr style="border-bottom: 1px solid black;">
                            <td></td><td></td><td></td><td>
                            </td><td></td><td style="border-left: 1px solid black; border-right: 1px solid black;"></td>
                          </tr>

                        </table>
                      </td>
                    </tr>

                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>`;
      });

      tempData += `</tbody></table>`;

      this.$refs.sheetsDataTableList.innerHTML = tempData;


      // exec table to excel
      var tableToExcel = (function () {
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>';
        var base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) };
        var format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };

        return function (table, name) {
          if (!table.nodeType) table = document.getElementById(table);
          var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
          var html = format(template, ctx);
          var blob = new Blob([html], { type: 'application/vnd.ms-excel' });
          var url = URL.createObjectURL(blob);

          var a = document.createElement('a');
          a.href = url;
          a.download = "Nota Transaksi Claim - " + moment(new Date()).format("DDMMYYhhmmss") + '.xls';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })();
      tableToExcel('exportedTable', 'NT KLAIM');
    }
  },
  mounted() {
    this.$Loading.config({
      color: '#ffffff',
      failedColor: '#f0ad4e',
      height: 10
    });

    // this.getTransactionNote()
  }
}

</script>



// WEBPACK FOOTER //
// ClaimTransactionNote.vue?2cca8526